module.exports = global["application_page_probandGroupCode"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./proband-group-code.ts");